<!-- New appointment options. -->
<app-mobappointments-options
	*ngIf="activeScreen === 'Options'"
	(changeScreen)="changeActiveScreen($event)"
	[returnTo]="returnTo"
></app-mobappointments-options>

<!-- New session. -->
<app-mobappointments-manage
	*ngIf="activeScreen === 'Session'"
	[editId]="editId"
	[addNew]="addNew"
	[contactId]="contactId"
	[returnTo]="returnTo"
	[operationType]="operationType"
	[calendarLabels]="calendarLabels"
	(changeScreen)="changeActiveScreen($event)"
></app-mobappointments-manage>
